<template>
  <div class="case-detail">
    <div v-if="optionsCtrl" class="more-options">
      <Dropdown
        transfer class="edit-icon"
        @on-click="option(caseDetail,$event)"
      >
        <a href="javascript:void(0)">
          <Icon type="ios-more" size="20" />
        </a>
        <DropdownMenu slot="list">
          <DropdownItem v-if="allocationCtrl" name="allocation">分配</DropdownItem>
          <DropdownItem v-if="caseDetail.state!='TN'&&caseDetail.terminationState!='P'" name="terminated">申请终止</DropdownItem>
          <DropdownItem v-if="caseDetail.caseCategory === 'N' && caseDetail.state !== 'ED'" name="changeCaseType">转案件类型</DropdownItem>
          <DropdownItem v-if="caseDetail.terminationState=='R'" name="rejectReason">查看驳回原因</DropdownItem>
          <DropdownItem name="caseNotes">备忘</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <slot name="close-icon"></slot>
    <div class="case-title">
      <span>{{ caseDetail.code }}</span>
      <span></span>
    </div>
    <div class="case-content">
      <Row class="case-detail-row">
        <Col span="2" class="right-label">项目：</Col><Col span="6" class="right-content">{{ caseDetail.projectName }}</Col>
        <Col span="2" class="right-label">负责人：</Col><Col span="6" class="right-content">{{ caseDetail.caseManager }}</Col>
        <Col span="2" class="right-label">方案代理律师：</Col><Col span="6" class="right-content">{{ caseDetail.programLawyerName }}</Col>
      </Row>
      <Row>
        <Col span="2" class="right-label">项目经理：</Col>
        <Col span="3" class="right-content">
          {{ caseDetail.projectManager }}
          <Tooltip :content="caseDetail.mobile" theme="light">
            <i class="icon icon-phone-01"></i>
          </Tooltip>
          <Tooltip :content="caseDetail.email" theme="light">
            <i class="icon icon-mail-01"></i>
          </Tooltip>
        </Col>
        <Col span="2" class="right-label">案件备注：</Col>
        <Col span="15" class="right-content">
          <Tooltip
            max-width="512" theme="light"
            :content="caseDetail.remark"
          >
            <div class="textoverOne" style=" -webkit-box-orient: vertical;"> {{ caseDetail.remark }}</div>
          </Tooltip>
        </Col>
      </Row>
    </div>
    <div class="case-detail-box" :style="{height:'calc(100% - '+otherHeight+')'}">
      <Row class="case-detail-tabs">
        <ul class="tabs-bar common-tabs-bar clearfix">
          <li
            v-if="!hiddenTab.includes('clueInfo')" :class="[tabsActive=='clueInfo'?'active':'']"
            @click="tabsActive='clueInfo';"
          >线索详情</li>
          <li
            v-if="!hiddenTab.includes('litigant')" :class="[tabsActive=='litigant'?'active':'']"
            @click="tabsActive='litigant';"
          >对方当事人</li>
          <li
            v-if="!hiddenTab.includes('caseEvidence')&& !hideCaseEvidence" :class="[tabsActive=='caseEvidence'?'active':'']"
            @click="tabsActive='caseEvidence';"
          >案件证据</li>
          <!-- 律师团队查看案件权限 viewPermission: all snap_shot -->
          <li
            v-if="caseDetail.type=='CL' && allowEdit && caseDetail.caseCategory !== 'E' && caseDetail.viewPermission === 'all' && !hiddenTab.includes('civilCase')" :class="[tabsActive=='civilCase'?'active':'']"
            @click="tabsActive='civilCase';"
          >案件流程</li>
          <li
            v-if="caseDetail.type=='AC' && allowEdit && caseDetail.caseCategory !== 'E' && caseDetail.viewPermission === 'all' && !hiddenTab.includes('administrativeCase')" :class="[tabsActive=='administrativeCase'?'active':'']"
            @click="tabsActive='administrativeCase';"
          >案件流程</li>
          <li
            v-if="caseDetail.type=='CC' && allowEdit && caseDetail.caseCategory !== 'E' && caseDetail.viewPermission === 'all' && !hiddenTab.includes('criminalCase')" :class="[tabsActive=='criminalCase'?'active':'']"
            @click="tabsActive='criminalCase';"
          >案件流程</li>

          <li
            v-if="caseDetail.viewPermission === 'all' && !hiddenTab.includes('agreement')" :class="[tabsActive=='agreement'?'active':'']"
            @click="tabsActive='agreement';"
          >案件结算协议</li>
          <li
            v-if="caseDetail.viewPermission === 'all' && !hiddenTab.includes('caseJournal')" :class="[tabsActive=='caseJournal'?'active':'']"
            @click="tabsActive='caseJournal';"
          >案件日志</li>
          <li
            v-if="caseDetail.viewPermission === 'all' && !hiddenTab.includes('caseNotes')" :class="[tabsActive=='caseNotes'?'active':'']"
            @click="tabsActive='caseNotes';"
          >案件备忘</li>
          <li
            v-if="caseDetail.viewPermission === 'all' && !hiddenTab.includes('caseDocument')" :class="[tabsActive=='caseDocument'?'active':'']"
            @click="tabsActive='caseDocument';"
          >案件文档</li>
          <li
            v-if="caseDetail.caseCategory==='I' && caseDetail.viewPermission === 'all' && !hiddenTab.includes('caseAttach')" :class="[tabsActive=='caseAttach'?'active':'']"
            @click="tabsActive='caseAttach';"
          >案件补充信息</li>
        </ul>
      </Row>
      <Row class="case-detail-container">
        <clue-info v-if="tabsActive==='clueInfo'" :clue-detail="clueDetail">
          <Row slot="code-label">
            <Col span="3" class="left-label">线索编号：</Col>
            <Col span="8" class="right-content">{{ clueDetail.code }}</Col>
            <Col span="3" class="left-label">报备团队：</Col>
            <Col span="8" class="right-content">{{ clueDetail.team }}</Col>
          </Row>
        </clue-info>
        <litigant
          v-if="tabsActive==='litigant'" :allow-edit="allowEdit"
          :case-id="caseDetail.id" :clue-detail="clueDetail"
          :clue-id="caseDetail.clueId" :project-id="caseDetail.projectId"
          :snap-shot="caseDetail.viewPermission === 'snap_shot'"
        />
        <case-evidence
          v-if="tabsActive==='caseEvidence'&& !hideCaseEvidence" :allow-edit="allowEdit"
          :case-detail="caseDetail" :clue-detail="clueDetail"
          :snap-shot="caseDetail.viewPermission === 'snap_shot'" v-on="$listeners"
        />

        <civil-case-progress
          v-if="tabsActive==='civilCase'" :case-id="caseDetail.id"
          :goto-node="gotoNode"
          :project-id="caseDetail.projectId" :case-state="caseDetail.state"
          :casetype="caseDetail.type" v-bind="$attrs"
        />
        <administrative-case-progress
          v-if="tabsActive==='administrativeCase'" :case-id="caseDetail.id"
          :project-id="caseDetail.projectId"
        />
        <criminal-case-progress
          v-if="tabsActive==='criminalCase'" :case-id="caseDetail.id"
          :project-id="caseDetail.projectId"
        />

        <div v-if="tabsActive==='agreement'">
          <Tabs :animated="false" style="padding-top:10px;">
            <TabPane v-if="caseDetail.type=='CL' " label="律师协议">
              <lawyer-agreement-info v-if="tabsActive==='agreement'" :agreement-detail="agreementDetail" />
            </TabPane>
            <TabPane v-if="caseDetail.type=='CC' " label="供应商协议">
              <supplier-agreement-info
                v-if="tabsActive==='agreement' && caseDetail.type=='CC'"
                :type="'supplier'" :case-detail="caseDetail"
                :cust-agreement-detail="criminalSupplierAgreementDetail"
              />
            </TabPane>
            <TabPane v-if="caseDetail.type=='AC' " label="供应商协议">
              <supplier-agreement-info
                v-if="tabsActive==='agreement' && caseDetail.type=='AC'" :case-detail="caseDetail"
                :type="'supplier'"
                :cust-agreement-detail="administrativeSupplierAgreementDetail"
              />
            </TabPane>
          </Tabs>
        </div>
        <case-document
          v-if="tabsActive==='caseDocument'" :case-id="caseDetail.id"
          :project-id="caseDetail.projectId"
        />
        <case-journal v-if="tabsActive==='caseJournal'" :case-id="caseDetail.id" />
        <case-notes v-if="tabsActive==='caseNotes'" :case-id="caseDetail.id" />
        <case-attach v-if="tabsActive==='caseAttach'" :case-id="caseDetail.id" />
      </Row>
    </div>

    <list-options
      :id="caseDetail.id" :type="type"
      :case-detail="caseDetail"
      :audit-note="caseDetail.auditNote" @reloadList="changeCtrl"
    />
  </div>
</template>
<script>
import clueInfo from './../clue/myClue/clueInfo.vue'
import litigant from './litigant.vue'
import caseEvidence from './caseEvidence.vue'
import caseAttach from './caseAttach.vue'
import lawyerAgreementInfo from './../agreement/lawyerAgreementInfo.vue'
import supplierAgreementInfo from './../agreement/supplierAgreementInfo.vue'
import caseJournal from './caseJournal.vue'
import caseNotes from './caseNotes.vue'
import listOptions from './plugins/listOptions.vue'
import civilCaseProgress from '../civilCase/index.vue'
import administrativeCaseProgress from '../administrativeCase/index.vue'
import criminalCaseProgress from '../criminalCase/index.vue'
import caseDocument from './caseDocument.vue'
export default {
  name: 'CaseDetail',
  components: {
    clueInfo,
    litigant,
    caseEvidence,
    lawyerAgreementInfo,
    supplierAgreementInfo,
    caseJournal,
    caseNotes,
    listOptions,
    civilCaseProgress,
    administrativeCaseProgress,
    criminalCaseProgress,
    caseAttach,
    caseDocument
  },
  props: {
    caseDetail: {
      type: Object
    },
    hideCaseEvidence: {
      type: Boolean,
      default: false
    },
    optionsCtrl: {
      type: [Object, Array, String, Boolean]
    },
    allocationCtrl: {
      type: Boolean,
      default: false
    },
    // 是否只读案件（案件包内未预约的案件详情是只读）
    allowEdit: {
      type: Boolean,
      default: true
    },
    active: {
      type: String
    },
    // 控制案件流程跳转节点
    gotoNode: {
      type: String
    },
    hiddenTab: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      tabsActive: 'clueInfo',
      clueDetail: '',
      agreementDetail: {},
      administrativeSupplierAgreementDetail: '',
      criminalSupplierAgreementDetail: '',
      type: '',
      otherHeight: ''
    }
  },
  created() {
    this.$store.dispatch('qcc/getQccData', this.caseDetail.id)
  },
  beforeMount() {},
  mounted() {
    if (this.caseDetail.caseCategory !== 'E' && this.allowEdit && this.caseDetail.viewPermission === 'all') {
      this.tabsActive = this.caseDetail.type == 'CL' ? 'civilCase' : (this.caseDetail.type == 'AC' ? 'administrativeCase' : 'criminalCase')
    }
    this.tabsActive = this.active || this.tabsActive
    this.otherHeight = (document.getElementsByClassName('case-content')[0].offsetHeight + 45) + 'px'
    this.getClueDetail()
    this.getLawyerArgreement()
    this.getAdministrativeSupplierAgreement()
    this.getCriminalSupplierAgreement()
  },
  updated() {},
  methods: {
    option(row, name) {
      this.type = name
    },
    // 关闭弹框
    changeCtrl(isReload) {
      if (this.tabsActive === 'caseNotes' && this.type === 'caseNotes') {
        this.$eventBus.$emit('refresh')
      }
      this.type = ''
    },
    getClueDetail() {
      const url = '/business/clue/view/' + this.caseDetail.clueId
      this.$get(url).then(res => {
        if (res.code === 0) {
          this.clueDetail = res.data
        }
      })
    },
    getLawyerArgreement() {
      if (!this.caseDetail.lawyerPriceId || this.caseDetail.type != 'CL') return false
      const url = `/settlement/agreement-price-lawyers/${this.caseDetail.lawyerPriceId}`
      this.$get(url).then(res => {
        this.agreementDetail = res.data || {}
      })
    },
    getAdministrativeSupplierAgreement() {
      if (!this.caseDetail.rewardSupplierPriceId || this.caseDetail.type != 'AC') return false
      const url = `/settlement/agreement/administrative/supplier/${this.caseDetail.rewardSupplierPriceId}`
      this.$get(url).then(res => {
        if (res.code === 0) {
          this.administrativeSupplierAgreementDetail = res.data || ''
        }
      })
    },
    getCriminalSupplierAgreement() {
      if (!this.caseDetail.rewardSupplierPriceId || this.caseDetail.type != 'CC') return false
      const url = `/settlement/agreement/criminal/supplier/${this.caseDetail.rewardSupplierPriceId}`
      this.$get(url).then(res => {
        if (res.code === 0) {
          this.criminalSupplierAgreementDetail = res.data || ''
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
 @import './caseDetail.scss';
</style>



// WEBPACK FOOTER //
// src/view/case/caseDetail.vue